import { Injectable } from "@angular/core";
import { BusinessResponseModel, BusinessService } from "../api-client";
import { BehaviorSubject, firstValueFrom } from "rxjs";
import { SwitchUserRequest, SwitchUserService } from "./switchuser.service";

@Injectable({ providedIn: 'root' })
export class BusinessIdService
{
    constructor(public autoApiBusinessService : BusinessService) { }

    // a user can be apart of multiple businesses
    // they can switch between them
    // we keep their current choosen business in session storage
    // edge case: user log outs, logout clears everything login does, and then logs back in. No session storage available
    // edge case: user changes business id, we can't logout as the business id will be removed from session on log bakc in
    // edge case 2: login as user1, session expired, firebase asks us to log back in, and log back in as user2 instead
    public async getCurrentBusinessId() : Promise<string>
    {
        // if no business is saved, just use the users first business
        let businessidSaved = sessionStorage.getItem('businessid-selected');

        // if no business id is saved, then just set the default one and return
        if(!businessidSaved)
        {
            const businessProfiles = (await firstValueFrom(this.autoApiBusinessService.businessGetUserBusinesses()));

            if(businessProfiles.length <= 0)
            {
                return "";
            }

            const businessIds = businessProfiles.map(e => e.businessId);
            sessionStorage.setItem('businessid-selected', businessIds[0]!);
            return businessIds[0]!;
        }

        // return one saved
        return businessidSaved;
    }
}